import { Component, Input, OnInit } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';
import { UiService } from '../../service/ui.service';
import { StatsOrderDetailComponent } from 'src/app/generales/components/stats-order-detail/stats-order-detail.component';

@Component({
  selector: 'app-state-account',
  templateUrl: './state-account.component.html',
  styleUrls: ['./state-account.component.scss'],
})
export class StateAccountComponent implements OnInit {
  @Input() admin = true;
  @Input() showTitle = true;
  @Input() set type(value){
    if(value){
      this._type = value;
      this.actualPage = 1;
      this.setSearch();
      this.searchTable();
    }
  };

  private _type = undefined;
  public gains = undefined;
  public filters: any = {};
  public users: any[] = [];
  public totalPages = 1;
  public actualPage = 1;

  constructor(
    private adminSv: AdminServiceService,
    private uiSv: UiService
  ) { }

  ngOnInit() {

  }

  async setFilters(ev){
    if(ev.month !== this.filters.month) {
      this.filters.month = ev.month
      await this.setSearch();
    };
    this.filters.search = ev.search;
    
    await this.searchTable();
  }

  async searchTable(){
    const actualDate = new Date();
    const resTable: any = await this.adminSv.get('userGain/sellerByTypes', '', { 
      type: this._type,
      month: this.filters.month || actualDate.getMonth(),
      search: this.filters.search || '',
      pag: this.actualPage
    });
    
    const data = resTable.data;
    this.users = data.data;
    this.totalPages = data.meta.last_page;
  }

  async showDetail(ev, user){
    let showStore = false;
    if(this._type === '0') showStore = true
    const { data } = await this.uiSv.createPop(
        StatsOrderDetailComponent, { user, showStore, admin: this.admin }, 'pop-detail');
    if(data){
      this.searchTable();
    }
  }

  async setSearch(){
    const actualDate = new Date();
    const res: any = await this.adminSv.get('userGain/totalSalesByTypes', '', { 
      type: this._type,
      month: this.filters.month || actualDate.getMonth()
    });
    this.gains = res.data
  }

  async changePage(ev){
    this.actualPage = ev;
    await this.searchTable();
  }

  trackByItems(index, item){
    return item.id;
  }
}
